export default __webpack_public_path__ + "static/media/risk.c52a7a87.jpg";